/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import { ComponentRenderer } from './ComponentRenderer';
import * as AllComponents from './components/nestedComponents';

export const NestedComponentRenderer = ({ components }) => (
  <ComponentRenderer components={components} allComponents={AllComponents} />
);
